import './MobileWarning.css';

const MobileWarning = (): React.ReactElement => {
  return (
    <div className="mobileWarning">
      <h2>Emeralds Catcher</h2>
      <p>
        Please visit emeralds.nxdec.io in the Meta Quest browser or use a web browser on a desktop, connect your headset
        and press Enter VR.
      </p>
    </div>
  );
};
export default MobileWarning;
